module.exports = __webpack_public_path__ + "media/lmpmatrix.c2a385d0.mp4";